const MODULE_NAME = 'socialNetworkActionsService';

export interface ISocialNetworkActionsService {
  closeSocialNetwork(): void;
  transferSocialNetwork(): void;
  conferenceSocialNetwork(): void;
  selectSocialNetwork(socialNetworkId: number): void;
  deselectSocialNetwork(): void;
  isSocialNetworkSelected(): boolean;
}

export class SocialNetworkActionsService implements ISocialNetworkActionsService {
  static $inject: Array<string> = [];

  public name = MODULE_NAME;
  private selectedSocialNetworkId: number | undefined;

  closeSocialNetwork(): void {
    this.selectedSocialNetworkId = undefined;
    // TODO: Must be implemented some logic for socialNetwork banner and maybe sockets. It will be implemented after merge of socialNetwork popup branch (Benik story)
  }

  conferenceSocialNetwork(): void {}

  selectSocialNetwork(socialNetworkId: number): void {
    this.selectedSocialNetworkId = socialNetworkId;
  }

  isSocialNetworkSelected(): boolean {
    return !!this.selectedSocialNetworkId;
  }

  transferSocialNetwork(): void {}

  deselectSocialNetwork(): void {
    this.selectedSocialNetworkId = undefined;
  }
}

export default MODULE_NAME;
